import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { InformationsService } from './informations.service';
import { AuthService } from '../../core/auth.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TinymceComponent } from 'angular2-tinymce';
import { AppService } from '../../app.service';

@Component({
    selector: 'basic-information-component',
    templateUrl: 'informations.component.html',
    styleUrls: ['informations.component.scss'],
    providers: [
        InformationsService
    ]
})

export class InformationsComponent implements OnInit {
    successMessage: string = '';
    searchTerms: string = '';
    formSubmitted: boolean = false;
    errorMessage = '';
    language = 'DE';
    params: any = {};
    form: FormGroup;
    informations: any;
    clinicId: any;
    languages = [];

    @ViewChild('description', {static: false}) private description: TinymceComponent;

    constructor(protected fb: FormBuilder,
                protected authService: AuthService,
                private route: ActivatedRoute,
                public router: Router,
                private appService: AppService,
                protected informationService: InformationsService) {
    }

    ngOnInit() {
        this.buildForm();
        this.route.params.subscribe(params => {
            this.params = params;

            if (params && params['lang']) {
                this.language = params['lang'];
            }
        });
        this.languages = JSON.parse(localStorage.getItem('languages'));
        return this.getInformations();
    }

    buildForm(): void {
        this.form = this.fb.group({
            'support_email': ['', [Validators.required]],
            'support_phone': ['', [Validators.required]],
            'support_template': [''],
        });
    }

    /**
     * Search email template
     */
    search() {
        if (!this.searchTerms) {
            return this.getInformations();
        }
    }

    resetSearch() {
        this.searchTerms = '';
    }

    getInformations() {
        this.appService.isLoading = true;
        this.informationService.read(this.language).subscribe((response) => {
            this.appService.isLoading = false;
            this.informations = response['infors'];
            if(!this.informations || !this.informations.length){
                return;
            }
            this.informations.forEach(information => {
                if (!this.language) {
                    return;
                }
                const frmField = information['name'].replace('_' + this.language, '');
                this.form.controls[frmField].setValue(information['text']);
            });
        });
    }

    selectInformationBylanguage(language) {
        this.language = language;
        return this.getInformations();
    }

    /**
     * Submit update of Basic Information
     *
     * @param language
     * @param basicForm
     */
    submit(basicForm: any, isValid: boolean): void {
        this.formSubmitted = true;

        if (!isValid) {
            return;
        }

        this.resetErrors();

        this.informationService.save(this.language, basicForm).subscribe(
            response => {
                this.successMessage = response['message'];
                let _self = this;
                setTimeout(function () {
                    _self.successMessage = '';
                }, 2000);
            });
    }

    resetErrors() {
        if (this.errorMessage.length > 0) {
            this.errorMessage = '';
        }
    }
}
